import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetCalenders,
  GetResourceCalendarsOfConfiguration,
  GetRessourceCalendar,
  GetPublicHolidayYears,
  SaveRessourceCalendar,
  UpdateRessourceCalendar,
  DeleteRessourceCalendar,
  GetSelectedLocationTree,
  GetFullLocationTree,
  GetLocationTree,
  GetGroupByOptions,
  GetLocationAccurationOptions,
  ImportPublicHolidays,
  GetPublicholidaytype,
  GetCalendersWithConfiguration,
  SaveConfigurationPublicHolidayType,
  GetConfigPublicHolidays,
  ExportPublicHolidays,
  ImportPublicHolidaysWithFile
};

function GetPublicholidaytype(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/publicholidaytype`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function ImportPublicHolidays(publicHolidaysObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourcecalendar/importpublicholidays`,
      publicHolidaysObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function ImportPublicHolidaysWithFile(
  importPublicHolidayFile,
  importOverride,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourcecalendar/importpublicholidaysfromressourcecalendar/` +
        importOverride,
      importPublicHolidayFile,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function ExportPublicHolidays(exportPublicHolidaysObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourcecalendar/exportpublicholidaysfromressourcecalendar?startDate=${
          exportPublicHolidaysObject.validFrom
        }&endDate=${exportPublicHolidaysObject.validTo}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetCalendersWithConfiguration(
  pageSize,
  pageNumber,
  searchValue,
  sortBy,
  sortOrder,
  configurationId,
  cityId,
  dateFrom,
  dateTo,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/ressourceCalendar?SearchValue=" +
        searchValue +
        "&PageSize=" +
        pageSize +
        "&PageNumber=" +
        pageNumber +
        "&SortBy=" +
        sortBy +
        "&SortOrder=" +
        sortOrder +
        "&ConfigurationId=" +
        configurationId +
        (cityId ? "&CityId=" + cityId : "") +
        (dateFrom ? "&DateFrom=" + dateFrom : "") +
        (dateTo ? "&DateTo=" + dateTo : ""),
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetCalenders(
  pageSize,
  pageNumber,
  searchValue,
  sortBy,
  sortOrder,
  dateFrom,
  dateTo,
  cityId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/ressourceCalendar?SearchValue=" +
        searchValue +
        "&PageSize=" +
        pageSize +
        "&PageNumber=" +
        pageNumber +
        "&SortBy=" +
        sortBy +
        "&SortOrder=" +
        sortOrder +
        (dateFrom ? "&DateFrom=" + dateFrom : "") +
        (dateTo ? "&DateTo=" + dateTo : "") +
        (cityId ? "&CityId=" + cityId : ""),
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetResourceCalendarsOfConfiguration(
  configurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/ressourceCalendar?" +
        `${
          configurationId && configurationId != null
            ? `ConfigurationId=${configurationId}`
            : ""
        }`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetRessourceCalendar(calendarId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/ressourceCalendar/${calendarId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetPublicHolidayYears(configurationId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourceCalendar/publicholidayyears/${configurationId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function SaveRessourceCalendar(calendar, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/ressourceCalendar`,
      calendar,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function UpdateRessourceCalendar(calendarId, calendar, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/ressourceCalendar/${calendarId}`,
      calendar,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function DeleteRessourceCalendar(calendarId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + `/ressourceCalendar/${calendarId}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function GetSelectedLocationTree(calendarId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourceCalendar/locationtree/selected/${calendarId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetFullLocationTree(calendarId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourceCalendar/locationtree/full/${calendarId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetLocationTree(selected, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourceCalendar/locationtree/${selected ? true : false}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function SaveConfigurationPublicHolidayType(
  configurationType,
  ressourceCalendarId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourcecalendar/configurationpublicholidaytype/${ressourceCalendarId}`,
      configurationType,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetLocationAccurationOptions(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/enumlist/locationinformationaccuration`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetGroupByOptions(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/enumlist/timegroupby`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetConfigPublicHolidays(
  contractNumber,
  versionNumber,
  editionNUmber,
  configurationId,
  startDate,
  endDate,
  language,
  workingDaysType,
  timeGroupBy,
  path,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  let url =
    process.env.VUE_APP_BASE_API_URL +
    `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNUmber}/configuration/${configurationId}/configpublicholiday/publicholidaydays`;
  url = startDate ? url + `?StartDate=${startDate}` : url;
  url = endDate ? url + `&EndDate=${endDate}` : url;
  url = language ? url + `&Language=${language}` : url;
  url = workingDaysType ? url + `&WorkingDaysType=${workingDaysType}` : url;
  url = timeGroupBy ? url + `&TimeGroupBy=${timeGroupBy}` : url;
  url = path ? url + `&PathFilter=${path}` : url;
  axios
    .get(url, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}
